import { Injectable, TemplateRef } from '@angular/core';
import { PlatformService } from '@services/platform/platform.service';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  bsModalRefs: BsModalRef[] = [];

  constructor(
    private bsModalService: BsModalService,
    private platformService: PlatformService,
  ) {}

  show<T>(
    content:
      | string
      | TemplateRef<unknown>
      | {
          new (...args: unknown[]): T;
        },
    config?: ModalOptions<T>,
  ): BsModalRef<T> {
    const bsModalRef = this.bsModalService.show(content, config);
    let modalClass = 'modal-dialog-float';
    if (this.platformService.platforms().includes('capacitor')) {
      modalClass += ' ios';
    }
    if (config && config.class) {
      modalClass += ` ${config.class}`;
    }
    if (
      config &&
      config.initialState &&
      config.initialState['removeFloatClass']
    ) {
      modalClass = modalClass.replace('modal-dialog-float', '');
    }
    bsModalRef.setClass(modalClass);
    // on hidden, remove from list
    bsModalRef?.onHidden?.subscribe(this.onModalHidden.bind(this, bsModalRef));
    this.bsModalRefs.push(bsModalRef);

    return bsModalRef;
  }

  hide(id?: number | string): void {
    this.bsModalService.hide(id);
  }

  hideMostRecent(): void {
    // popping here is fine, because the hidden handler
    // will just not modify the list as the modal is already gone
    const mostRecentRef = this.bsModalRefs.pop();
    mostRecentRef?.hide();
  }

  hideAll(): void {
    // have to copy refs because hiding modals modifies the list
    // as they're hidden.
    const refsCopy = this.bsModalRefs.map((r) => r);
    for (const bsModalRef of refsCopy) {
      bsModalRef.hide();
    }
  }

  onModalHidden(bsModalRef: BsModalRef): void {
    // unsub from hidden event
    bsModalRef?.onHidden?.unsubscribe();
    this.bsModalRefs = this.bsModalRefs.filter((ref) => ref !== bsModalRef);
  }
}
